import React, { useState, useRef, Component } from "react"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import Slider from "react-slick"
import { RightArrowSlider, LeftArrowSlider } from "../../icons"
import StructuredText from "../custom-structured-text-renderer"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

const TeamValueSlider = ({ title, items }) => {
  const slider = useRef()
  const [current, setCurrent] = useState(0)

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    fade: false,
    autoplay: true,
    speed: 15000,
    autoplaySpeed: 0,
    centerMode: true,
    variableWidth: true,
    className: "slider variable-width",
    afterChange: (current, next) => {
      setCurrent(current)
    },
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          fade: true,
          speed: 500,
          autoplay: false,
          centerMode: false,
          slidesToScroll: 1,
          variableWidth: false,
        }
      }
    ]
  }

  return (
    <section className="team-value-slider">
      {
        title &&
        <div className="team-value-slider__title">
          <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>
        </div>
      }
      <div className='team-value-slider__inner'>
        <div className="team-value-slider__items" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          {
            items?.length > 0 &&
            <BlockUpdate>
              <Slider ref={slider} {...settings}>
                {
                  items?.map((el, i) => (
                    <div key={i} className="team-value-slider__item">
                      {el.image && <Asset asset={el.image} />}
                      <div className='team-value-slider__item-title'>
                        {el.title && <h3>{parse(el.title)}</h3>}
                        <span>{current + 1} / {items.length}</span>
                      </div>
                      {el.richContent && <StructuredText data={el.richContent} />}
                    </div>
                  ))
                }
              </Slider>
            </BlockUpdate>
          }
          <div className="team-value-slider__arrows">
            <button onClick={() => slider.current.slickPrev()}><LeftArrowSlider /></button>
            <button onClick={() => slider.current.slickNext()}><RightArrowSlider /></button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TeamValueSlider

export const query = graphql`
fragment TeamValueSliderProps on DatoCmsTeamValueSlider {
  ... on DatoCmsTeamValueSlider {
    id
    title
    items {
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
    }
  }
}
`